/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SyncDefs from './defs.defs.js'

const $nsid = 'com.atproto.sync.getHostStatus'

export { $nsid }

/** Returns information about a specified upstream host, as consumed by the server. Implemented by relays. */
const main = l.query(
  $nsid,
  l.params({ hostname: l.string() }),
  l.jsonPayload({
    hostname: l.string(),
    seq: l.optional(l.integer()),
    accountCount: l.optional(l.integer()),
    status: l.optional(
      l.ref<SyncDefs.HostStatus>((() => SyncDefs.hostStatus) as any),
    ),
  }),
  ['HostNotFound'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
